module.exports = __webpack_public_path__ + "img/scb.e4747e9f.png";